import { ElLoading } from 'element-plus'
import { ElMessage } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import { ElNotification } from 'element-plus'
import { JSEncrypt } from "jsencrypt";
import axios from 'axios'
import { pinyin } from 'pinyin-pro';
import { tc } from '@/languages';

let loading = undefined;

const showLoading = () => {
    loading = ElLoading.service({
        lock: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.7)',
    });
}

const closeLoading = () => {
    if (loading != undefined) {
        loading.close();
        loading = undefined;
    }
}

const showConfirm = (title, text, option) => {
    option = {
        ...{
            confirmButtonText: tc('global.Confirm'),
            cancelButtonText: tc('global.Cancel'),
        }, ...option
    };

    return ElMessageBox.confirm(text, title, option);
};

const showAlert = (title, text, option) => {
    return ElMessageBox.alert(text, title, option);
}

const showMessage = (type, msg) => {
    //type:message,success,warning,error
    ElMessage({ message: msg, type: type, });
}

const showNotification = (type, title, msg) => {
    ElNotification({ title: title, message: msg, type: type, });
}

const refreshPublicKey = () => {
    let json = localStorage.getItem('PublicKey');
    let obj = JSON.parse(json);

    if (obj === null || obj.validityTime === null || new Date() > obj.validityTime) {
        showLoading();
        getNewKey();
    } else {
        showLoading();
        axios.get('/MainSite/Valid', { params: { context: rsaEncrypt("Hello") } })
            .then(response => {
                if (!response.success) {
                    getNewKey();
                }
            }).catch(() => {
                getNewKey();
            }).then(() => {
                closeLoading();
            });
    }
}

const getNewKey = () => {
    axios.get('/MainSite/RSAKey/Key').then(response => {
        let obj = {};
        obj.key = response.content;
        obj.validityTime = new Date().setMinutes(new Date().getMinutes() + 10);
        localStorage.setItem('PublicKey', JSON.stringify(obj));
    }).then(() => {
        closeLoading();
    });
}

const rsaEncrypt = (text) => {
    let key = JSON.parse(localStorage.getItem('PublicKey')).key
    let jsEncrypt = new JSEncrypt({ default_key_size: 2048 });
    jsEncrypt.setPublicKey(key);
    return jsEncrypt.encrypt(text);
}

const getShortName = (name) => {
    return pinyin(name, { pattern: 'first', toneType: 'none', type: 'string' }).replace(/\s/g, '').toUpperCase();
}

const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let fileResult = '';
        reader.readAsDataURL(file.raw);
        reader.onload = () => fileResult = reader.result;
        reader.onerror = error => reject(error);
        reader.onloadend = () => resolve(fileResult);
    });
};

const isEmpty  = (str) => {
    return str === undefined || str === null || str === '';
}

const deepClone = (obj) => {
    var target = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] === 'object') {
                target[key] = deepClone(obj[key]);
            } else {
                target[key] = obj[key];
            }
        }
    }
    return target;
}

export {
    showLoading, closeLoading, showMessage, showConfirm, showAlert, showNotification,
    refreshPublicKey, rsaEncrypt, getShortName, toBase64, deepClone,isEmpty
}